module.exports = __webpack_public_path__ + "static/media/1f44d.040deb1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f44d.svg
// module id = 621
// module chunks = 1